module.exports = __webpack_public_path__ + "img/verifireWhite.f183224f.svg";